export default "__VITE_ASSET__CRzUk1$J__"